import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../context/theme'
import { Button } from './ui/button'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const toggle = () => setTheme(theme === 'dark' ? 'light' : 'dark')

  return (
    <Button variant="ghost" size="icon-sm" onClick={toggle} aria-label="Toggle theme" className="relative">
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  )
}
